import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const EventCheckinDashboard = lazy(() => import("@/pages/admin/EventCheckinDashboard"));
import { AdminLayout } from "@/components/admin/AdminLayout";
export const Route = createFileRoute("/admin/event-checkin")({
  component: () => (
    <AdminLayout requiredPermission="view_dinners">
      <EventCheckinDashboard />
    </AdminLayout>
  ),
});
